import emailjs, { EmailJSResponseStatus } from "@emailjs/browser";

export interface EmailData {
  from_name: string;
  email_address: string;
  phone_number: string;
  message: string;
}

export interface SendEmailOptions {
  serviceId?: string;
  templateId?: string;
  userId?: string;
}

const DEFAULT_SERVICE_ID = import.meta.env.VITE_EMAILJS_SERVICE_ID || "";
const DEFAULT_TEMPLATE_ID = import.meta.env.VITE_EMAILJS_TEMPLATE_ID || "";

export const sendEmailService = (
  data: EmailData,
  options: SendEmailOptions = {}
): Promise<EmailJSResponseStatus> => {
  const serviceId = options.serviceId || DEFAULT_SERVICE_ID;
  const templateId = options.templateId || DEFAULT_TEMPLATE_ID;
  
  if (!serviceId || !templateId) {
    return Promise.reject(new Error("EmailJS service or template ID not configured"));
  }
  
  return emailjs.send(serviceId, templateId, { ...data });
};
